import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { postData } from "../../api";
import { blogData } from "../../utils/blogData";
import blogDefaultImg from "../../assets/images/blog-default.png";

const defaultBlogData = [];

let imageUrl = "https://www.centillionsoftechhrm.com/api/v1/resources/blogs/";
const normalizeBlog = (blog) => {
  const id = blog?._id || blog?.id || blog?.blogId || blog?.slug;
  const excerpt =
    blog?.excerpt ||
    blog?.summary ||
    blog?.shortDescription ||
    (typeof blog?.content === "string"
      ? blog.content.replace(/<[^>]+>/g, "").slice(0, 140)
      : "") ||
    "Read more about this update from Centillion Softech.";

  const date =
    blog?.date ||
    (blog?.createdAt ? new Date(blog.createdAt).toLocaleDateString() : "Recent") ||
    "Recent";

  return {
    id,
    title: blog?.title || blog?.name || "Untitled blog",
    author: blog?.author || blog?.createdBy || "Centillion Softech",
    image: blog?.image || blog?.coverImage || blog?.featuredImage || blogDefaultImg,
    excerpt,
    date,
    content: blog?.content || "",
  };
};

const BlogComponent = () => {
  const [blogs, setBlogs] = useState(defaultBlogData);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBlogs = async () => {
      try {
        const result = await postData(`${process.env.REACT_APP_BASEURL}/blog/get`, {});
        const apiBlogs = result?.data?.data || result?.data || [];
        const normalizedBlogs = Array.isArray(apiBlogs) ? apiBlogs.map(normalizeBlog) : defaultBlogData;

        if (normalizedBlogs.length > 0) {
          setBlogs(normalizedBlogs);
        }
      } catch (error) {
        setBlogs(defaultBlogData);
      } finally {
        setLoading(false);
      }
    };

    loadBlogs();
  }, []);

  return (
    <section className="blog-section py-100 pb-5">
      <Container>
        <Row className="justify-content-center mb-5 pt-60">
          <Col md={8} className="text-center">
            <span className="about-badge mb-3">Latest Updates</span>
            <h2 className="banner-title mb-3" style={{ fontSize: "3rem" }}>
              Our <span className="gradient-text pb-2">Blog & Insights</span>
            </h2>
            <p className="about-description">
              Stay updated with the latest trends, expert insights, and success stories
              from the world of technology and digital innovation.
            </p>
          </Col>
        </Row>
        <Row>
          {loading ? (
            <Col className="text-center py-5">
              <p>Loading blogs...</p>
            </Col>
          ) : (
            blogs.map((blog) => (
              <Col lg={4} md={6} key={blog.id || blog.title} className="mb-4">
                <div className="blog-card h-100 d-flex flex-column">
                  <div className="card-img-wrapper">
                    <span className="blog-date-badge">
                      <i className="far fa-calendar-alt me-2"></i>
                      {blog.date}
                    </span>
                    <img
                      src={blog.image ? imageUrl + blog.image : blogDefaultImg}
                      alt={blog.title}
                      onError={(e) => { e.target.onerror = null; e.target.src = blogDefaultImg; }}
                    />
                  </div>
                  <div className="blog-content d-flex flex-column flex-grow-1">
                    <div className="blog-meta-item">
                      <i className="far fa-user"></i>
                      <span>{blog.author}</span>
                    </div>

                    <h3 className="blog-title">
                      <Link to={`/blog-details/${blog.id}`}>{blog.title}</Link>
                    </h3>

                    <p className="blog-excerpt">{blog.excerpt}</p>

                    <div className="mt-auto pt-3">
                      <Link to={`/blog-details/${blog.id}`} className="read-more-btn">
                        Read Full Article <i className="fas fa-arrow-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
            ))
          )}
        </Row>
      </Container>
    </section>
  );
};

export default BlogComponent;
